export default "/_next/static/images/img3-86a74d371d6ada6647a37899d8bdd77c.png";